import { useEffect } from 'react'
import { syncTest } from './session'

/**
 * ASM-985: renders nothing; tells the lock session which test this page shows and whether it
 * is editing it. Mounted by every test-editing page (test page, doc-based / video quiz page).
 */
const EditLockKeeper = ({ test, editing }) => {
  useEffect(() => {
    if (test?._id) syncTest({ test, editing })
  })
  return null
}

export default EditLockKeeper
